"use client"
import React from "react";
import UralityImage from "@/components/shared/UralityImage";
import UralityVideo from "@/components/shared/UralityVideo";

import { Ratio } from "react-bootstrap";
import ReactPlayer from "react-player";

const AssetContent = ({ asset, autoPlay, children }) => {
  return (
    <Ratio aspectRatio="16x9">
      <div style={{ overflow: "hidden" }}>
        {asset.assetType === "IMAGE" && (
          <>
            {asset.base64 ? (
              <UralityImage base64={asset.base64} tag="Image" size="sm" />
            ) : (
              <UralityImage imageId={asset.id} tag="Image" size="sm" />
            )}
          </>
        )}
        {asset.assetType === "VIDEO" && (
          <>
            {asset.assetSource === "URALITY" ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <UralityVideo asset={asset} autoPlay={autoPlay} />
              </div>
            ) : (
              <div className="urality-video-wrapper">
                <ReactPlayer
                  className="react-player"
                  playsinline
                  width={"100%"}
                  height={"100%"}
                  controls={true}
                  url={asset.id}
                  playing={autoPlay}
                />
              </div>
            )}
          </>
        )}
        {children}
      </div>
    </Ratio>
  );
};
export default AssetContent;
